import { TblColType } from '../table.types';
import { sortTextFn } from './sortTextFn';
import { sortDateFn } from './sortDateFn';
import { sortBooleanAsStringFn } from './sortBooleanAsStringFn';

export function sortFnByColType(colType: TblColType, col: string, dir: 'ASC' | 'DSC'): (a: any, b: any) => number {
    switch (colType) {
        case 'TEXT':
            return sortTextFn(col, dir);
        case 'DROPTEXT':
            return sortTextFn(col, dir);
        case 'DATE':
            return sortDateFn(col, dir);
        case 'MULTITEXT':
            return sortTextFn(col, dir);
        case 'BOOLEAN':
            return sortBooleanAsStringFn(col, dir);
        case 'NUMBER':
            return (a, b) => {
                const aVal = typeof a[col] === 'number' ? a[col] : parseFloat(a[col]) || 0;
                const bVal = typeof b[col] === 'number' ? b[col] : parseFloat(b[col]) || 0;

                if (aVal === bVal) {
                    return 0;
                }
                return dir === 'DSC' ? bVal - aVal : aVal - bVal;
            };

        case 'COMMA_SEPARATED_NUMBER':
            // Treat value as a single number (remove commas) for intuitive numeric sorting
            return (a, b) => {
                const parseNumber = (val: any): number =>
                    typeof val === 'string'
                        ? parseFloat(val.replace(/,/g, '').trim())
                        : typeof val === 'number'
                          ? val
                          : 0;
                const aVal = parseNumber(a[col]);
                const bVal = parseNumber(b[col]);
                if (aVal === bVal) {
                    return 0;
                }
                return dir === 'DSC' ? bVal - aVal : aVal - bVal;
            };
        case 'CURRENCY':
            return (a, b) => {
                const parseNumber = (val: any): number =>
                    typeof val === 'number' ? val : parseFloat(String(val ?? '').replace(/[^0-9.-]/g, '')) || 0;
                const aVal = parseNumber(a[col]);
                const bVal = parseNumber(b[col]);
                if (aVal === bVal) {
                    return 0;
                }
                return dir === 'DSC' ? bVal - aVal : aVal - bVal;
            };
        case 'MULTISELECT':
            // Sort multi-select like text
            return sortTextFn(col, dir);
        default:
            throw new Error('table.util.sortFnByType, col type not supported: ' + colType);
    }
}
